<template>
  <div class="basicInformation common_group annualBasicInformation">
    <div class="title">
      <img src="@/assets/images/informationIcon.png">
      <span>基础信息</span>
    </div>
    <el-form
      class="common_form"
      label-position="left"
      ref="basicInformation"
      :model="formData"
      :rules="rules"
      label-width="180px"
      :validate-on-rule-change="false"
    >
      <el-row>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="申请人">
            <el-input v-if="!isLoading" v-model="formData.submitUser" disabled />
          </el-form-item>
        </el-col>
        <!-- 年度 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="规划年度" prop="year">
            <el-select
              v-if="!isLoading"
              v-model="formData.year"
              placeholder="请选择规划年度"
              clearable
              :disabled="isReadonly"
            >
              <el-option v-for="item in yearList" :key="item.year" :label="item.year" :value="item.year" />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 类型 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="类型" prop="type">
            <el-select
              v-if="!isLoading"
              v-model="formData.type"
              placeholder="请选择类型"
              clearable
              :disabled="isReadonly"
              @change="handleTypeChange"
            >
              <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 区域/行业 -->
        <el-col v-if="formData.type" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item v-if="!isLoading" :label="formData.type === 'REGION' ? '区域：' : '行业：'" prop="departmentId">
            <el-select
              v-if="!isReadonly"
              v-model="formData.departmentId"
              :placeholder="formData.type === 'REGION' ? '请选择区域' : '请选择行业'"
              clearable
              :disabled="isReadonly"
              @change="handleDepartmentChange"
            >
              <el-option v-for="item in commonList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <div v-else class="label-text">{{ formData.departmentName }}</div>
          </el-form-item>
        </el-col>
        <!-- 年度整合营销规划文档 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="年度整合营销规划文档" prop="docLink">
            <el-input
              v-if="!isLoading"
              v-model.trim="formData.docLink"
              placeholder="请输入年度整合营销规划文档"
              clearable
              :disabled="isReadonly"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { isNotEmpty } from '@/utils/utils';
import { annualApplicationApi } from '../../service';
import { newApplicationFormApi } from '../../../newApplicationForm/service/index';
export default {
  name: 'BasicInformation',
  props: {
    editEchoData: {
      type: Object,
      default: () => {}
    },
    useType: {
      type: String,
      default: 'activity'
    },
    isLoading: {
      type: Boolean,
      default: true
    },
    isReadonly: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      rules: {
        year: [
          { required: true, message: '请选择年度', trigger: 'change' }
        ],
        type: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        docLink: [
          { required: true, message: '请输入年度整合营销规划文档', trigger: 'blur' }
        ]
      },
      formData: {
        submitUser: '', // 申请人
        year: null, // 年度
        type: '', // 类型
        departmentId: '', // 区域/行业
        docLink: '' // 年度整合营销规划文档
      },
      financialSystemList: [],
      currencyList: [],
      saleList: [],
      saleLoading: false,
      lang: localStorage.getItem('lang') || 'zh-CN',
      typeList: [
        { label: '区域', value: 'REGION' },
        { label: '行业', value: 'INDUSTRY' }
      ],
      commonList: [],
      areaList: [],
      industryList: [],
      yearList: []
    };
  },
  watch: {
    editEchoData: {
      handler (newVal) {
        // 获取编辑回显数据
        if (isNotEmpty(newVal)) {
          this.formData = {
            submitUser: newVal.submitUserName ? `${newVal.submitUserName} / ${newVal.submitDeptName}` : '',
            departmentId: newVal.departmentId || '',
            departmentName: newVal.departmentName || '',
            type: newVal.type || '',
            year: newVal.year || '',
            docLink: newVal.docLink || ''
          };
          this.handleTypeCommonChange(this.formData.type);
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted () {
    if (this.$route.path === '/annualPlanApplication') {
      this.init();
    }
  },
  methods: {
    init () {
      this.getCurrentYear();
      this.getIndustryList();
      this.getAreaList();
      const userInfo = this.$store.state.userInfo;
      // 申请人
      this.formData.submitUser = `${userInfo.sysUser.userName} / ${userInfo.sysUser.deptName}`;
    },
    // 获取当前年度列表
    getCurrentYear () {
      annualApplicationApi.currentYear().then(res => {
        if (res.status === '200') {
          this.yearList = res.data;
        }
      });
    },
    // 获取区域列表
    getAreaList () {
      newApplicationFormApi.getRegionName().then(res => {
        if (res.status === '200') {
          const data = JSON.parse(JSON.stringify(res.data));
          this.areaList = data.map(item => {
            return {
              label: item.value,
              value: item.key
            };
          });
        }
      });
    },
    // 获取行业列表
    getIndustryList () {
      newApplicationFormApi.getActivityList(['annual_industry']).then(res => {
        if (res.status === '200') {
          const data = JSON.parse(JSON.stringify(res.data));

          this.industryList = data.annual_industry.map(item => {
            return {
              label: item.fieldValue,
              value: item.fieldValue2
            };
          });
        }
      });
    },
    // 类型变化
    handleTypeChange (val) {
      this.$set(this.formData, 'departmentId', '');
      this.$set(this.formData, 'departmentName', '');
      this.$refs.basicInformation.clearValidate();
      this.handleTypeCommonChange(val);
    },
    handleTypeCommonChange (val) {
      if (val === 'REGION') {
        this.commonList = this.areaList;
        this.$set(this.rules, 'departmentId', [
          { required: true, message: '请选择区域', trigger: 'change' }
        ]);
      } else if (val === 'INDUSTRY') {
        this.$set(this.rules, 'departmentId', [
          { required: true, message: '请选择行业', trigger: 'change' }
        ]);
        this.commonList = this.industryList;
      } else {
        this.commonList = [];
      }
      this.$emit('typeChange', val);
    },
    validateHandler () {
      return new Promise((resolve, reject) => {
        this.$refs['basicInformation'].validate((valid) => {
          if (valid) {
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    },
    handleDepartmentChange (val) {
      const index = this.commonList.findIndex(item => item.value === val);
      if (index !== -1) {
        this.$set(this.formData, 'departmentName', this.commonList[index].label);
      } else {
        this.$set(this.formData, 'departmentName', '');
      }
    }
  }
};
</script>

<style lang="scss">
.annualBasicInformation{
  input,
  select,
  textarea,
  .el-input__inner,
  .el-textarea__inner,
  .el-select .el-input__inner {
    border: 1px solid #dcdfe3 !important;
  }
  .is-disabled .el-input__inner {
    border-color: transparent !important;
  }
}
.label-text{
  padding: 0 15px;
}
</style>
